<template>
  <div
    class="flex flex-row items-center justify-center w-8 h-8 p-2 rounded-xl"
    :class="
      route === $route.name ?
        'bg-theme text-white':
        'dark:bg-slate-700 bg-slate-200 text-theme'
    "
  >
    <i class="fa pi" :class="icon"></i>
  </div>

  <span :class="route === $route.name ? 'font-bold':'font-light'">
    {{ label }}
  </span>

  <span
    v-if="count > 0"
    class="rounded-full p-[0.15rem_0.25rem] text-xxs font-bold text-white bg-theme"
  >
    {{ count }}
  </span>
</template>


<script>
  export default {
    name: "AsideLink",
    props: {
      label: {
        type: String,
        required: true,
      },
      route: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
        default: ""
      },
      count: {
        type: Number,
        default: 0
      }
    }
  };
</script>
